export default {
  methods: {
    async pageLoad() {
      this.error = false;
      this.errmsg = null;
      this.loading = true;
      const rowId = this.$route.params.rowId || "new";
      try {
        const response = (await this.$axios({
          url: `pages/client/${this.$route.params.pageId}/${rowId}`,
          method: "get"
        })).data;

        const page = response.results;
        this.content = page.content;
      } catch (e) {
        this.handleError(e);
      }
      this.loading = false;
    }
  }
};
